import actions from "./action";
import { TopicsService } from "../../services/topicsService";

const { assignedUserTopicsBegin, assignedUserTopicsSuccess, assignedUserTopicsErr } = actions;

const getAssignedTopics = () => {
  return async (dispatch) => {
    try {
      dispatch(assignedUserTopicsBegin());
      const topics = await TopicsService.getAssignedTopics();
      dispatch(assignedUserTopicsSuccess(topics.topics));
    } catch (error) {
      dispatch(assignedUserTopicsErr(error));
    }
  }
}

export { getAssignedTopics };